<template>
  <div>
    <!--  标题及按钮  -->
    <mtd-row class="margin-bottom-0">
      <mtd-col :span="12" class="height-full">
        <span class="page-title-32">文件外发记录</span>
      </mtd-col>
    </mtd-row>
    <!--  关键字检索  -->
    <mtd-row style="margin-top: 12px;">
      <mtd-col :span="24" class="policy-search-block">
        <mtd-form inline :label-width="74">
          <mtd-row :gutter="16">
            <mtd-col :span="8" style="padding-left: 0;">
              <mtd-form-item label="MISID:">
                <mtd-select v-model="search_form.creator" placeholder="请输入用户MISID" :filterable="true" clearable
                            style="width: 100%" :remote="true" :remote-method="searchPerson" :debounce="500"
                            key="search_misid">
                  <mtd-option v-for="item in person_groups" :key="item.name + '/' + item.mis"
                              :label="item.name + '/' + item.mis" :value="item.mis"/>
                </mtd-select>
              </mtd-form-item>
            </mtd-col>
            <mtd-col :span="8">
              <mtd-form-item label="组织架构:">
                <mtd-select v-model="search_form.creatorOrganization" placeholder="请输入组织架构" clearable
                            no-match-text="无结果，请确认是否是正确的部门链" style="width: 100%" :filterable="true"
                            :remote="true" :remote-method="searchDepart" :debounce="500" key="search_org" clearable>
                  <mtd-option v-for="(item,index) in depart_groups" :key="index" :label="item" :value="item"/>
                </mtd-select>
              </mtd-form-item>
            </mtd-col>
            <mtd-col :span="8" style="padding-right: 0;">
              <mtd-form-item label="申请时间:">
                <mtd-date-picker type="daterange" placeholder="起始日期 ~ 结束日期" value-format="yyyy-MM-dd" clearable
                                 class="search_datetime_range" style="width: 100%;" :options="date_range_option"
                                 v-model="search_form.date_range"/>
              </mtd-form-item>
            </mtd-col>
            <mtd-col :span="8" style="padding-left: 0;">
              <mtd-form-item label="文件名称:" style="margin-bottom: 0;">
                <mtd-input type="text" style="width: 100%;" placeholder="请输入文件名称"
                           v-model="search_form.fileName" :clearable="true"/>
              </mtd-form-item>
            </mtd-col>
            <mtd-col :span="8" :offset="8" style="padding-right: 0; text-align: right;">
              <mtd-button type="text-primary" style="width: 70px;" @click="reset_search_form">重置</mtd-button>
              <mtd-button ghost type="primary" style="width: 80px;" @click="list_table_data">搜索</mtd-button>
            </mtd-col>
          </mtd-row>
        </mtd-form>
      </mtd-col>
    </mtd-row>
    <!--  表格数据  -->
    <div style="margin-top: 12px">
      <mtd-table size="small" :data="file_out_apply_list" reserve-selection>
        <mtd-table-column type="expand" width="40">
          <template slot-scope="scope">
            <div style="padding: 12px 40px;background-color: #F7F7F7;">
              <div class="file-content-div">
                <h2 class="apply-content">包含的文件</h2>
                <div v-for="item in scope.row.fileNames" class="file-name">{{ item }}</div>
              </div>
              <div class="file-content-div">
                <h2 class="apply-content">外发流程</h2>
                <div class="file-name">{{ scope.row.strategyName || '免审批' }}</div>
              </div>
              <div class="file-content-div">
                <h2 class="apply-content">外发原因</h2>
                <div class="file-name">{{ scope.row.reason || '无' }}</div>
              </div>
              <div class="file-content-div">
                <h2 class="apply-content">外发邮箱</h2>
                <div class="file-name">{{ scope.row.emails || '无' }}</div>
              </div>
              <div class="file-content-div">
                <h2 class="apply-content">文件分享链接</h2>
                <div class="file-name"><a :href="scope.row.downloadUrl" target="_blank">{{ scope.row.downloadUrl }}</a>
                </div>
              </div>
              <div class="file-content-div">
                <h2 class="apply-content">提取密码</h2>
                <div class="file-name">{{ scope.row.downloadPassword || '无' }}</div>
              </div>
            </div>
          </template>
        </mtd-table-column>
        <mtd-table-column prop="creator" label="MISID"/>
        <mtd-table-column prop="creatorOrganization" label="组织架构" width="400" show-overflow-tooltip/>
        <mtd-table-column prop="id" label="申请编号" width="100"/>
        <mtd-table-column prop="fileNumber" label="文件数量" width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.fileNames.length }}个文件</span>
          </template>
        </mtd-table-column>
        <mtd-table-column prop="checkStatus" label="审批状态" width="100">
          <template slot-scope="scope">
            <!-- 审批中-->
            <div v-if="scope.row.status == 0">
              <i class='mtdicon mtdicon-time-o'
                 style="color: #0A70F5;margin-right: 4px;font-size: 16px;vertical-align: middle;"></i>
              <span style="vertical-align: middle;">审批中</span>
            </div>
            <!-- 已通过-->
            <div v-if="scope.row.status == 1">
              <i class='mtdicon mtdicon-success-o'
                 style="color: #00b365;margin-right: 4px;font-size: 16px;vertical-align: middle;"></i>
              <span style="vertical-align: middle;">已通过</span>
            </div>
            <!-- 已驳回-->
            <div v-if="scope.row.status == 2">
              <i class='mtdicon mtdicon-error-o'
                 style="color: #f5483b;margin-right: 4px;font-size: 16px;vertical-align: middle;"></i>
              <span style="vertical-align: middle;">已驳回</span>
            </div>
          </template>
        </mtd-table-column>
        <mtd-table-column prop="createTime" label="申请时间" width="150">
          <template slot-scope="scope">
            {{ scope.row.createTime|dateTimeFormat }}
          </template>
        </mtd-table-column>
        <mtd-table-column prop="createTime" label="链接过期时间" width="150">
          <template slot-scope="scope">
            <span v-if="scope.row.expireTime === 0">已终止</span>
            <span v-else>{{ scope.row.expireTime|dateTimeFormat }}</span>
          </template>
        </mtd-table-column>
        <mtd-table-column prop="operation" label="操作" width="210">
          <template slot-scope="scope">
            <mtd-button type="text-primary" size="small"
                        v-clipboard:copy="copyMessage"
                        v-clipboard:success="copySuccess"
                        v-clipboard:error="copyError"
                        @click="copyUrl(scope.$index)"
                        style="padding-right: 12px;margin:0">复制链接
            </mtd-button>
            <mtd-button type="text-primary" size="small" @click="check_process(scope.$index)"
                        style="padding-left: 0;padding-right: 12px;margin-right: 0"
                        :disabled="scope.row.bpmAddress == null || scope.row.bpmAddress === ''">审批进度
            </mtd-button>
            <mtd-button type="text-primary" size="small" @click="terminate_file_out(scope.row.id)"
                        style="padding-left: 0;padding-right: 0;margin-right: 0"
                        :disabled="scope.row.outOfDate || scope.row.isTerminated || scope.row.status !== 1">
              <span v-if="scope.row.isTerminated">已禁止外发</span>
              <span v-else>禁止外发</span>
            </mtd-button>
          </template>
        </mtd-table-column>
      </mtd-table>
      <mtd-pagination v-if="search_form.total > 10" :total="search_form.total" :show-total="true"
                      :current-page.sync="search_form.currentPage" @change="select_record_list()"
                      size="small" style="float: right;margin-top: 12px"/>
    </div>
  </div>
</template>

<script>

import {mapActions} from "vuex";
import moment from "moment";

export default {
  name: "file_out_list",
  filters: {
    dateTimeFormat(dateTime) {
      return moment(dateTime)
        .utcOffset(480)
        .format('YYYY-MM-DD HH:mm:ss');
    },
  },
  data() {
    const today = new Date();
    const shortcuts = [
      {
        text: "最近一天",
        value() {
          return [today, today];
        },
      },
      {
        text: "最近一周",
        value() {
          const oneWeek = new Date();
          oneWeek.setTime(today.getTime() - 3600 * 1000 * 24 * 7);
          return [oneWeek, today];
        },
      },
      {
        text: "最近一月",
        value() {
          const oneMonth = new Date();
          oneMonth.setTime(today.getTime() - 3600 * 1000 * 24 * 30);
          return [oneMonth, today]
        },
      },
    ];
    return {
      date_range_option: {
        shortcuts,
        disabledDate: function (date) {
          if (date && date.getTime() > Date.now()) {
            return true;
          }
          if (date && date.getTime() < (Date.now() - 91 * 24 * 3600 * 1000)) {
            return true;
          }
          return false;
        }
      },
      search_form: {
        keyword: '',
        creator: null,
        fileName: null,
        creatorOrganization: null,
        date_range: [],
        currentPage: 1,
        limit: 10,
        total: 0,
      },
      file_out_apply_list: [],
      copyMessage: '',
      person_groups: [],
      depart_groups: [],
    }
  },
  computed: {},
  mounted() {
  },
  methods: {
    ...mapActions([
      'queryOtherFileOutRecordList',
      'query_mis_id_list',
      'query_org_list',
      'terminateFileOutByOthers',
    ]),
    select_record_list() {
      if (this.search_form.date_range.length === 2) {
        this.search_form.startTime = this.search_form.date_range[0] + " 00:00:00";
        this.search_form.endTime = this.search_form.date_range[1] + " 23:59:59";
      } else {
        this.search_form.startTime = null;
        this.search_form.endTime = null;
      }
      if ((!this.search_form.creator || this.search_form.creator === '')
        && (!this.search_form.creatorOrganization || this.search_form.creatorOrganization === '')) {
        this.$mtd.message.success('请输入MISID或者组织架构进行查询！');
        return;
      }
      this.queryOtherFileOutRecordList(this.search_form).then(res => {
        this.file_out_apply_list = res.data.items;
        this.search_form.total = res.data.total;
      })
    },
    list_table_data() {
      this.search_form.currentPage = 1;
      this.select_record_list();
    },
    copyUrl(index) {
      let url = this.file_out_apply_list[index].downloadUrl;
      let password = this.file_out_apply_list[index].downloadPassword;
      let info = '文件分享链接：' + url + '\n提取密码：' + password;
      this.copyMessage = info;
    },
    copySuccess() {
      this.$mtd.message({
        message: '链接已复制到剪切板',
        type: 'success',
      });
    },
    copyError() {
      this.$mtd.message({
        message: '复制失败',
        type: 'error',
      });
    },
    back_to_file_out() {
      this.$router.push({path: "file_upload"});
    },
    check_process(id) {
      let url = this.file_out_apply_list[id].bpmAddress;
      window.open(url);
    },
    terminate_file_out(id) {
      this.terminateFileOutByOthers({id: id}).then(res => {
        if (res.code === 0) {
          this.$mtd.message.success('禁止外发成功');
        } else {
          this.$mtd.message.error(res.message);
        }
        this.list_table_data();
      }).catch(err => {
        this.$mtd.message.error('禁止外发失败');
      })
    },
    reset_search_form() {
      this.search_form = {
        keyword: '',
        creator: null,
        fileName: null,
        creatorOrganization: null,
        date_range: [],
        currentPage: 1,
        limit: 10,
        total: 0,
      }
    },
    // 搜索mis
    searchPerson(keyword) {
      if (keyword != null && keyword !== "") {
        this.query_mis_id_list({keyword}).then(res => {
          this.person_groups = res.data
        }).catch((err) => {
          console.log(err)
        })
      }
    },
    // 搜索BU BG
    searchDepart(keyword) {
      if (keyword != null && keyword !== "") {
        keyword = keyword.replace(/\//g, "-");
        this.query_org_list({keyword}).then(res => {
          this.depart_groups = res.data
        }).catch((err) => {
          console.log(err)
        })
      }
    },
  }
}
</script>

<style>
@import "../../../styles/reset_table.css";

.margin-bottom-0 {
  margin-bottom: 0;
}

h2.dd-page-title {
  font-size: 20px;
  color: rgba(0, 0, 0, 0.84);
  line-height: 32px;
  margin-bottom: 16px;
}

h2.apply-content {
  font-size: 14px;
  line-height: 22px;
  margin-bottom: 12px;
}

.mtd-table-cell {
  font-size: 12px;
}

.mtd-table .mtd-table-expanded-cell {
  padding: 0 !important;
}

.mtd-table-expanded-cell > .mtd-table-cell {
  height: auto;
}

.file-name {
  font-size: 14px;
  margin-bottom: 8px;
}

.file-content-div {
  margin-bottom: 12px;
}

.mtd-btn-small {
  padding: 0;
}

.mtd-message {
  min-width: 20px;
  padding: 6px 16px;
}

.policy-search-block .mtd-form-item {
  width: 100%;
}

.policy-search-block {
  background: #F7F7F7;
  padding: 12px 16px;
}
</style>

